<template>
  <!-- 系统整体页面布局 -->
  <el-container class="el-container">
    <!-- 页面头部区域 高度默认60px -->
    <el-header :class="$store.getters.showHeader == true ? 'el-header' : 'el-header1'">
      <div :style="{

          display: $store.getters.showHeader == true ? 'block' : 'none',
        }">
        <img style="width: 95px; height:25px;float: left; " src="../assets/LOGO_1.png" />
        <!-- <div class="contract">
          <i @click="contractEvt(1)" v-if="contractNum == 2" class="el-icon-s-unfold"></i>
          <i @click="contractEvt(2)" v-else class="el-icon-s-fold"></i>
        </div> -->
      </div>

      <div class="headerMenu"  style="margin-left:70px;" :style="{ display: $store.getters.showHeader == true ? 'block' : 'none' }">
        <el-menu class="el-menu-demo" mode="horizontal" :default-active="activeIndex" @select="topMenuEvt">
          <el-menu-item index="1">参考图</el-menu-item>
          <el-menu-item index="2">模型</el-menu-item>
          <el-menu-item index="3">PS素材</el-menu-item>
          <el-menu-item index="4">用户</el-menu-item>
          <el-menu-item index="7">标签</el-menu-item>
          <el-menu-item index="5">收入</el-menu-item>
          <el-menu-item index="6">搜索</el-menu-item>
          <el-menu-item index="8">AI</el-menu-item>
          <el-menu-item index="9">工具</el-menu-item>
        </el-menu>
      </div>
      <div class="block" :style="{ display: $store.getters.showHeader == true ? 'block' : 'none' }"
        style="position: absolute;right: 20px;">
        <el-dropdown @command="outLoginEvt">
          <span class="el-dropdown-link">
            <el-avatar src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"></el-avatar>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="1">退出登陆</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-header>
    <el-container>
      <!-- 左侧菜单栏部分 -->
      <el-aside v-if="contractNum == 1" class="el-aside">
        <el-scrollbar class="menu_scroll">
          <Menus />
        </el-scrollbar>
      </el-aside>
      <!-- 右侧主题页面内容展示 -->
      <el-main class="el-mian">
        <!-- 路由页面 -->
        <router-view></router-view>
      </el-main>
    </el-container>

    <div v-if="$store.getters.coverShow == true" @click="coverEvt" class="cover_box"></div>
  </el-container>
</template>

<script>
  import Menus from "./components/incomeMenu.vue";
  import { outLoginApi } from "../apis/loginApi";
  import { showMenuApi } from "../apis/ces/a";
  export default {
    components: {
      Menus,
    },
    data() {
      return {
        circleUrl: "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
        //左侧菜单默认数据
        menuList: [],
        //头部默认数据
        activeIndex: "5",
      };
    },
    computed: {
      contractNum: {
        get() {
          return this.$store.getters.contractNum;
        },
        set() { },
      },
      setSwitch: {
        get() {

          return this.$store.getters.setSwitch;
        },
      }
    },
    watch: {},
    created() {
      showMenuApi().then((res) => {
        if (res.code == 1000) {
          this.$store.dispatch("setContractNum", res.data.open);
        }
      });
    },
    mounted() {
       const location = this.$store.getters.location;
     },
    methods: {

      //退出登录清除token
      outLoginEvt(e) {
        if (e == 1) {
          outLoginApi().then((res) => {
            if (res.code === 1000) {
              localStorage.removeItem("token");
              this.$router.push("/login");
            }
          });
        }
      },
      //按钮展开收回
      contractEvt(num) {
        showMenuApi({ open: num }).then((res) => {
          if (res.code == 1000) {
            this.$store.dispatch("setContractNum", res.data.open);
          }
        });
      },
      handleSelect(e) {
        // this.$emit('fatherMethod');
        if (e == this.$route.path) {
          return;
        }
        this.$router.push(e);
      },
      //侧边栏
      topMenuEvt(e) {
        if (e == 1) {
          this.menuList = [
            {
              id: "1",
              title: "参考图进度",
              children: [
                {
                  id: "1_1",
                  title: "原始素材",
                  next: "/original",
                },
                {
                  id: "1_2",
                  title: "上架中",
                  next: "/grounding",
                },
                {
                  id: "1_3",
                  title: "下架中",
                  next: "/undercarriage",
                },
                {
                  id: "1_4",
                  title: "回收站",
                  next: "/retrieve",
                },
              ],
            },
            {
              id: "2",
              title: "固定标签",
              children: [
                {
                  id: "2_1",
                  title: "标签",
                  next: "/label",
                },
              ],
            },
          ];
          this.$router.push("/Back");
        } else if (e == 2) {
          this.menuList = [
            {
              id: "1",
              title: "模型进度",
              children: [
                {
                  id: "1_1",
                  title: "原始素材",
                  next: "/original",
                },
                {
                  id: "1_2",
                  title: "整理中",
                  next: "/1223",
                },
                {
                  id: "1_3",
                  title: "上架中",
                  next: "/grounding",
                },
                {
                  id: "1_4",
                  title: "下架中",
                  next: "/undercarriage",
                },
                {
                  id: "1_5",
                  title: "回收站",
                  next: "/retrieve",
                },
              ],
            },
            {
              id: "2",
              title: "模型分类",
              children: [
                {
                  id: "2_0",
                  title: "未分类",
                  next: "/0",
                },
                {
                  id: "2_2",
                  title: "人",
                  next: "/1",
                },
                {
                  id: "2_3",
                  title: "交通",
                  next: "/2",
                },
                {
                  id: "2_1",
                  title: "植物",
                  next: "/199",
                },
                {
                  id: "2_4",
                  title: "家具",
                  next: "/12432",
                },
                {
                  id: "2_6",
                  title: "场景",
                  next: "/1123123",
                },
              ],
            },
            {
              id: "3",
              title: "自定义标签",
              children: [
                {
                  id: "3_1",
                  title: "人",
                  next: "/1",
                },
                {
                  id: "3_@",
                  title: "交通",
                  next: "/2",
                },
                {
                  id: "3_#",
                  title: "植物",
                  next: "/199",
                },
                {
                  id: "3_7",
                  title: "家具",
                  next: "/12432",
                },
                {
                  id: "3_6",
                  title: "场景",
                  next: "/1123123",
                },
              ],
            },
          ];
          this.$router.push("/model");
        } else if (e == 3) {
          this.menuList = [
            {
              id: "1",
              title: "模型进度",
              children: [
                {
                  id: "1_1",
                  title: "原始素材",
                  next: "/original",
                },
                {
                  id: "1_2",
                  title: "上架中",
                  next: "/grounding",
                },
                {
                  id: "1_3",
                  title: "下架中",
                  next: "/undercarriage",
                },
                {
                  id: "1_4",
                  title: "回收站",
                  next: "/retrieve",
                },
              ],
            },
            {
              id: "2",
              title: "模型分类",
              children: [
                {
                  id: "2_0",
                  title: "未分类",
                  next: "/0",
                },
                {
                  id: "2_1",
                  title: "人",
                  next: "/1",
                },
                {
                  id: "2_2",
                  title: "植物",
                  next: "/199",
                },
              ],
            },
          ];
          this.$router.push("/PSpeople");
        } else if (e == 4) {
          this.$router.push("/user");
        } else if (e == 5) {
          this.$router.push("/income_box");
        } else if (e == 6) {
          this.$router.push("/Search_Records");
        } else if (e == 7) {
          this.$router.push("/Reference_statistics");
        } else if (e == 8) {
          this.$router.push("/ai");
        }
        else if (e == 9) {
          this.$router.push("/translate_fanyi");
        }

        this.$store.dispatch("setMenuList", this.menuList);
      },
      coverEvt() {
        this.$store.dispatch("setCoverShow", false);
      },
    },
  };
</script>

<style scoped>
  .contract {
    cursor: pointer;
    margin-left: 20px;
    float: left;
    color: #409eff;
  }

  .cover_box {
    position: fixed;
    z-index: 452;
    top: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgb(95, 94, 94, 0.4);
  }

  /*铺满屏幕，没有边距*/
  .el-container {
    padding: 0px;
    margin: 0px;
    height: 100vh;
  }

  .el-header {
    /* 顶部部分的高度(默认60px) */
    color: #ffffff;
    font-size: 20px;
    display: flex;
    /* justify-content: space-between; */
    align-items: center;
    height: 60px;
    z-index: 12;
    box-shadow: 0px 1px 3px 1px rgba(226, 226, 226, 0.4);
    transition: all 0.8s ease 0s;
    border-bottom: 1px solid #c2b8b89c;


  }

  .el-header1 {
    color: #ffffff;
    font-size: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 0px !important;
  }

  .el-aside {
    width: 10% !important;
    max-width: 260px !important;
    min-width: 180px !important;
    min-height: calc(100vh - 60px);
    border-right: 1px solid #e5e5e5;
  }

  .el-aside .el-menu {
    width: 90%;
    min-height: 100%;
    border: none;
    margin-left: 5%;
    font-weight: normal;
  }

  .el-menu span {
    margin-left: 10px;
  }

  .el-mian {
    /*background-color: #e5e5e5;*/
    min-width: 1200px;
    position: relative;
    padding: 0px;
    margin: 0;
    height: 100vh;
    overflow: hidden;
    /* height: calc(100vh - 60px);*/
  }

  .el-aside .is-active {
  border-radius: 8px;
  background-color:#F0F0F0 ;
  color: #373535;
}

  .headerMenu {
    height: 58px;
  }

  .headerMenu .el-menu--horizontal {
    border: none;
  }

  .headerMenu .el-menu {
    background-color: rgba(226, 226, 226, 0) !important;
  }

  >>>.el-submenu__title {
    font-family: Avenir, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
      "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji",
      "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji", sans-serif;
    font-size: 12px !important;
    height: 40px;
    line-height: 40px;
    margin-top: 5px;
  }

  .el-menu-item:focus,
  .el-menu-item:hover {
    border-radius: 8px;
    background-color: rgba(233, 244, 254, 1);
  }

  .el-menu-demo .el-menu-item:hover {
    border-radius: 0px;
  }

  .el-menu-demo .el-menu-item {
    border-radius: 0;
    font-size: 12px;
  }

  .menu_scroll {
    overflow-x: hidden;
  }

  >>>.is-horizontal {
    display: none;
  }

  >>>.is-opened ul li div {
    border-bottom: 1px solid #eee;
    background: none !important;
  }

  >>>.leftMenu .is-opened {
    background: none !important;
  }

  >>>.el-menu-item-group__title {
    display: none;
  }

  >>>.el-scrollbar__wrap {
    overflow-y: scroll;
  }
  @media screen and (min-width:0px)and (max-width: 1920px) {
  .headerMenu {
    height: 58px;
    margin-left: 70px !important;
  }
}
  @media screen and (min-width:1921px)and (max-width: 2560px) {
  .headerMenu {
    height: 58px;
    margin-left: 140px !important;
  }
}
@media screen and (min-width: 2561px)and (max-width: 3440px) {
  .headerMenu {
    height: 58px;
    margin-left: 140px !important;
  }
}
@media screen and (min-width: 3441px)and (max-width: 3840px) {
  .headerMenu {
    height: 58px;
    margin-left: 140px !important;
  }
}



.switching{
  width:60px;
  height: 20px;
  font-size: 14px;
  color:#000;
  padding:2px 8px;
}
</style>



// WEBPACK FOOTER //
// src/income/index.vue